<template>
  <div>
    <b-input-group>
      <b-form-select v-model="newRule.rule" :options="validationRulesOptions"/>
      <b-form-input v-if="newRule.rule === 'custom'" v-model="newRule.custom" placeholder="wprowadź regułę"/>
      <b-form-input v-model="newRule.errorMessage" placeholder="Treść komunikatu błędu*" @keyup.enter="addRule(newRule)" />
      <b-button size="sm" variant="success" @click="addRule(newRule)"><i class="fa fa-plus"></i></b-button>
    </b-input-group>
  </div>
</template>
<script>

import formHelper from './formHelper'

export default {
  props: ['fieldType'],
  data () {
    return {
      validationRulesOptions: this.buildRuleOptions(this.fieldType),
      newRule: this.emptyRule()
    }
  },
  watch: {
    fieldType: function (fieldType) {
      this.validationRulesOptions = this.buildRuleOptions(fieldType)
    }
  },
  name: 'c-rule-creator',
  methods: {
    emptyRule () {
      return {
        rule: 'required',
        errorMessage: '',
        custom: null
      }
    },
    addRule (rule) {
      if (rule.errorMessage === '') {
        this.$alert('Podaj treść komunikatu błędu')
        return
      }
      if (rule.custom) {
        rule.rule = rule.custom
      }
      delete rule.custom
      this.$emit('rule-added', rule)
      this.newRule = this.emptyRule()
    },
    ruleText (rule) {
      return formHelper.ruleText(rule)
    },
    buildRuleOptions (fieldType) {
      let availableOptions = ['required', 'email', 'phone', 'nip', 'custom', 'postCodePL', 'url:https,http']
      if (['textarea', 'checkbox', 'select'].includes(fieldType)) {
        availableOptions = ['required', 'custom']
      }
      return formHelper.buildRuleOptions(availableOptions)
    }
  }
}
</script>
